export const redirectToWhatsapp = (phoneNumber) => {
  const whatsappUrl = `https://wa.me/+972${phoneNumber}`;
  window.open(whatsappUrl, "_blank");
};
